import React, { useState } from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";

import { Alert, Avatar, Paper, Snackbar, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";

import SuperAdmin from "../../components/auth/SuperAdmin";

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

const BigAvatar = styled(Avatar)`
  width: 92px;
  height: 92px;
  text-align: center;
  margin: 0 auto ${(props) => props.theme.spacing(5)};
`;

function AdminLogin() {
  const location = useLocation();
  const [message, setMessage] = useState(location?.state?.message || null);
  const [alertOpen, setAlertOpen] = useState(
    location?.state?.alertOpen || false
  );

  const handleAlertClose = () => {
    setAlertOpen(false);
    setMessage(null);
  };

  return (
    <React.Fragment>
      {message && (
        <Snackbar
          open={alertOpen}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={handleAlertClose}
        >
          <Alert severity="success">{message}</Alert>
        </Snackbar>
      )}

      <Wrapper>
        <Helmet title="Alpha Plus" />
        <BigAvatar alt="alpha_plus" src="/static/img/avatars/admin.png" />

        <Typography component="h1" variant="h3" align="center" gutterBottom>
          SUPER ADMIN LOGIN
        </Typography>
        <Typography component="h2" variant="body1" align="center">
          Sign in to your account to continue
        </Typography>

        <SuperAdmin />
      </Wrapper>
    </React.Fragment>
  );
}

export default AdminLogin;
